import AboutTeam from '../components/AboutTeam';
import Careers, { getComponentProps as getCareerProps } from '../components/Careers';
import ContactMap from '../components/ContactMap';
import DesignImages from '../components/DesignImages';

const getAdditionalPageContent = (slug: string) => {
  let Footer: any = () => null;
  let getComponentProps: any;
  switch (slug) {
    case 'about':
      Footer = AboutTeam;
      break;
    case 'design':
      Footer = DesignImages;
      break;
    case 'contact':
      Footer = ContactMap;
      break;
    case 'careers':
      Footer = Careers;
      getComponentProps = getCareerProps;
      break;
    default:
    //
  }
  return {
    Footer,
    getComponentProps,
  };
};

export default getAdditionalPageContent;
